import WaterQualityStatusColor from '../../waterQuality/map/WaterQualityStatusColor';

export default function WaterQualityData(currentMode, currentArea, datas, dataTime) {
  let filterAreaData;
  const mode = currentMode;
  const area = currentArea;

  if (mode === 'province' && area.code !== '0') {
    filterAreaData = datas.filter((d) => d.waterquality_station.province_code === area.code);
  } else if (mode === 'basin' && area.code !== '0') {
    filterAreaData = datas.filter((d) => d.basin.basin_code === parseInt(area.code, 10));
  } else {
    filterAreaData = datas;
  }

  const dataFilterArea = filterAreaData
    .filter((d) => d.waterquality_salinity !== null || d.waterquality_do != null)
    .map((row) => {
      const salinityStatus = WaterQualityStatusColor(row.waterquality_salinity, 'salinity');
      const doStatus = WaterQualityStatusColor(row.waterquality_do, 'do');
      return {
        level: salinityStatus.level,
        do_level: doStatus.level,
        name: (row.waterquality_station.waterquality_station_name.th).includes('สถานี') ? row.waterquality_station.waterquality_station_name.th : `สถานี${row.waterquality_station.waterquality_station_name.th}`,
        id: row.id,
        tele_station_lat: row.waterquality_station.waterquality_station_lat,
        tele_station_long: row.waterquality_station.waterquality_station_long,
        agency_name: row.waterquality_station.agency_name.th,
        datetime: row.waterquality_datetime,
        tele_station_name: row.waterquality_station.waterquality_station_name.th,
        tumbon_name: row.waterquality_station.tumbon_name.th,
        amphoe_name: row.waterquality_station.amphoe_name.th,
        province_name: row.waterquality_station.province_name.th,
        river_name: row.waterquality_station.river_name,
        waterquality_salinity: row.waterquality_salinity,
        waterquality_do: row.waterquality_do,
        waterquality_ph: row.waterquality_ph,
        waterquality_turbid: row.waterquality_turbid,
        waterquality_tds: row.waterquality_tds,
      };
    });

  // salinity ความเค็ม
  // level 3 red เกินเกณฑ์คุณภาพน้ำเพื่อการผลิตน้ำประปา
  // level 4 = เกินเกณฑ์มาตรฐานน้ำใช้เพื่อการเกษตร
  // ใช้เกณฑ์มาตรฐานน้ำดิบเพื่อผลิตน้ำประปา (เพิ่มเกณฑ์อื่นๆ เช่น เกณฑ์มาตรฐานน้ำใช้เพื่อการเกษตร)
  // เกณฑ์ 0.25 กรัม/ลิตร ให้แสดงข้อความ “เกณฑ์เฝ้าระวังคุณภาพน้ำดิบเพื่อผลิตน้ำประปา”
  // เกณฑ์ 0.5 กรัม/ลิตร ให้แสดงข้อความ “เกณฑ์มาตรฐานน้ำดิบเพื่อผลิตน้ำประปา” (มากกว่า 0.5)
  // เกณฑ์ มากกว่า 2 กรัม/ลิตร "เกณฑ์มาตรฐานเพื่อการเกษตร 2.00 กรัมต่อลิตร

  // waterquality_do ค่าออกซิเจนละลายน้ำ red = level 2
  // พบค่า do เป็น 0 หน่วยงานแจ้งว่าอาจจะเกิดจากตรวจวัดได้จริง หรือ หัววัดเสีย
  // ดังนั้น จึงไม่เอาค่า do มาเป็นเกณฑ์ในการแสดงผล

  // แสดงเป็นรายสถานี
  const varYellow = dataFilterArea.filter((d) => d.level === 2)
    .sort((a, b) => a.name.localeCompare(b.name, 'th'));

  const varRed = dataFilterArea.filter((d) => d.level === 3)
    .sort((a, b) => a.name.localeCompare(b.name, 'th'));

  const varDarkRed = dataFilterArea.filter((d) => d.level === 4)
    .sort((a, b) => a.name.localeCompare(b.name, 'th'));

  // นับจำนวนสถานีเกินมาตรฐาน
  const wqCount = (varRed.length + varDarkRed.length);

  const wqList = {
    time: dataTime,
    count: wqCount,
    yellow: varYellow,
    red: varRed,
    darkRed: varDarkRed,
  };

  // แผนที่ แสดงตำแหน่งของสถานีที่มีค่าความเค็มเกิน 0.25 g/l
  const wqFilterLevel = dataFilterArea.filter((d) => d.level >= 3);

  return ({
    wqCount,
    wqList,
    wqFilterLevel,
  });
}
